module.exports = __webpack_public_path__ + "resources/6529039b5bd390a8b2260f48418cb112.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/bar-background.jpg
// module id = 211
// module chunks = 0